/**
 * @module Nameplate
 */

import Component from '../../base/Component';
import '../../../images/sprite/medal.svg';
import './styles.css';

/**
 * Название компонента.
 */
export default class Nameplate extends Component {
    static className = 'nameplate';
}
